export type PrepaidRestrictionRequestContext = {
  customerId: number;
  selectedTenantId: number | null;
  requestId: number;
};

let latestRestrictionRequestId = 0;
let latestAppliedRestrictionRequestId = 0;
const customerInfoRequestContexts = new WeakMap<
  object,
  PrepaidRestrictionRequestContext
>();

export const startPrepaidRestrictionRequest = (): number =>
  ++latestRestrictionRequestId;

export const registerCustomerInfoRestrictionRequest = (
  customer: object | undefined,
  requestContext: PrepaidRestrictionRequestContext,
): void => {
  if (!customer) return;
  customerInfoRequestContexts.set(customer, requestContext);
};

export const getCustomerInfoRestrictionRequest = (
  customer: object | undefined,
): PrepaidRestrictionRequestContext | undefined =>
  customer ? customerInfoRequestContexts.get(customer) : undefined;

export const createCustomerInfoRestrictionUpdate = (
  customer: { prepaid_charge_restriction_flg?: number } | undefined,
): { prepaid_charge_restriction_flg?: number } | undefined => {
  const requestContext = getCustomerInfoRestrictionRequest(customer);
  if (!customer || !requestContext) return undefined;

  const restrictionUpdate = {
    prepaid_charge_restriction_flg: customer.prepaid_charge_restriction_flg,
  };
  registerCustomerInfoRestrictionRequest(restrictionUpdate, requestContext);
  return restrictionUpdate;
};

export const markPrepaidRestrictionRequestApplied = (
  requestId: number,
): boolean => {
  if (requestId <= latestAppliedRestrictionRequestId) return false;
  latestAppliedRestrictionRequestId = requestId;
  return true;
};
